











































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'
import AudienceListingThumbnail from '@ui/cards/AudienceListingThumbnail'
import VendorListingThumbnail from '@ui/cards/VendorListingThumbnail'
import FeedCardCenter from '@ui/Campaign/pipeline/EventFeed/FeedCardCenter'
import ActivationPlanOfferWrapper from '@ui/Campaign/pipeline/EventFeed/activation/ActivationPlanOfferWrapper'
import VendorListingsPricingDisplay from '@ui/Campaign/pipeline/EventFeed/activation/VendorListingsPricingDisplay'

settings =
  name: 'OfferCard'

  resources:
    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'
      fetch: false

  vue:
    props: ['offer']

    components: {
      AudienceListingThumbnail,
      VendorListingThumbnail,
      FeedCardCenter,
      ActivationPlanOfferWrapper,
      VendorListingsPricingDisplay,
    }

    computed:
      campaignId: -> @$route.params.campaignId
      audienceListing: -> @ctxAudienceListing(@offer)
      vendorListing: -> @ctxVendorListing(@offer)
      hasAudienceListing: -> @audienceListing?.id?
      event: -> @ctxEvent(@offer)
      startedInThePast: -> @offer.activation_starts?.includes('ago')

      isPending: -> 'submitted' is @offer.state
      isCanceled: -> 'canceled' is @offer.state

      poLineItems: -> @ctxPurchaseOrder(@offer).line_items
      listingLineItem: -> @poLineItems[0]
      segment: -> @poLineItems[0]?.segment

      styleForOfferState: ->
        state = @offer.state
        data = {
          accepted: 'bg-green text-white',
          denied: 'bg-red text-white',
          submitted: 'bg-orange text-white',
          draft: 'bg-orange text-white',
          default: 'bg-grey text-black'
        }
        data[state] || data['default']

      activationPlan: -> @offer.activation_plan

    methods:
      navigateToDetails: -> @$router.push({ name: 'OfferShowPage', params: { offerId: @offer.id, tab: 'overview' } })

export default VueOptions.vue settings
